
import Tooltip from "@/components/tooltip/tooltip.vue";
import TimeLine from "@/components/timeline/timeline.vue";
import TimeLineItem from "@/components/timeline/timelineItem.vue";
export default {
  inject: ["showFooter", "switchHeaderStatus"],
  head() {
    return {
      script: [
        { src: 'https://hm.baidu.com/hm.js?bca287ea2f695c8758d364d29d58ef85' }
      ]
    }
  },
  data() {
    return {
      scale: 100,
      padding: 0,
      timeLineList: [
        {
          id: 9,
          year: "2022",
          descript: ["惠州公司荣获高新企业荣誉"],
        },
        {
          id: 0,
          year: "2021",
          descript: ["深圳公司荣获高新企业荣誉"],
        },
        {
          id: 1,
          year: "2019",
          descript: ["江苏医疗生物科技大厦落成启用",],
        },
        {
          id: 2,
          year: "2013",
          descript: [
            "医疗用品暨生物科技研发中心成立",
          ],
        },
        {
          id: 3,
          year: "2006",
          descript: [
            "惠州多泰生产基地落成启用",
          ],
        },
        { id: 4, year: "1996", descript: ["电子应用技术中心成立，为欧美客户提供PCB，FPC薄膜开关类产品设计制造代工"] },
        {
          id: 5,
          year: "1995",
          descript: ["获得北美多家百强企业的战略供应商合作伙伴，提供精密模具及塑胶硅胶橡胶零件设计制造"],
        },
        {
          id: 6,
          year: "1990",
          descript: ["深圳总公司，沛鸿工业园落成启用"],
        },
        { id: 7, year: "1987", descript: ["成功开拓德国市场，获得多家知名企业指定成为绩优供应商战略伙伴"] },
        { id: 8, year: "1978", descript: ["经数年筹备于1978年在台北正式成立"] },
      ],
      qualificationList: [
        {
          id: 1,
          img: require("../assets/img/system/gaoxinjishuqiye.jpg"),
          title: "深圳高新技术企业证书",
        },
        {
          id: 2,
          img: require("../assets/img/system/iso13485.png"),
          title: "医疗 ISO 13485 证书",
        },
        {
          id: 3,
          img: require("../assets/img/system/iso14001.png"),
          title: "ISO 14001 证书",
        },
        {
          id: 4,
          img: require("../assets/img/system/iso9001.png"),
          title: "ISO 9001 QMS 证书",
        },
      ],
      switch: false
    };
  },
  computed: {
    slotName(param) {
      return () => {
        console.log("param", param);
        return param % 2 === 0 ? "bottom" : "top";
      };
    },
  },
  mounted() {
    // 显示footer
    this.showFooter(true);
    this.switchHeaderStatus(true);
  },
  methods: {
    // 视频滚轮滑动
    videoWheel(e) {
      const docScrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (e.wheelDelta < 0 && this.scale < 600) {
        e.preventDefault();
      }
      if (docScrollTop === 0 && e.wheelDelta > 0 && this.scale > 100) {
        this.scale -= 10;
        this.padding -= 5;
      } else if (e.wheelDelta < 0 && this.scale <= 600) {
        this.scale += 10;
        this.padding += 5;
      }
    },
    // 时间线左右切换点击
    timelineclick(param) {
      if (param === "left") {
        this.switchAnimation(-300);
      } else if (param === "right") {
        this.switchAnimation(300);
      }
    },
    switchAnimation(distance) {
      if(this.switch) {
        return
      }
      this.switch = true
      const target = this.$refs.timeline.scrollLeft + distance;
      console.log(target)
      if (target < 0 || target > 2100) {
      this.switch = false
        return
      }
      let timer = null;
      console.log(target, this.$refs.timeline.scrollLeft)

      timer = setInterval(() => {
        let speed = 3;
      //   console.log(this.$refs.timeline)
        const left = this.$refs.timeline.scrollLeft;
        console.log(left)
        if (Math.abs(target - left) > speed) {
          speed = target - left > 0 ? speed :  speed * -1;
          this.$refs.timeline && ( this.$refs.timeline.scrollLeft = left + speed)
        } else {
          clearInterval(timer)
          this.switch = false
           this.$refs.timeline && (this.$refs.timeline.scrollLeft = target);
        }
      }, 10);
      // const aniFunc = () => {
      //   let speed = 5;
      //   console.log(this.$refs.timeline)
      //   const left = this.$refs.timeline.scrollLeft;
      //   if (Math.abs(target - left) > speed) {
      //     speed = target - left > 0 ? speed : speed * -1;
      //     this.$refs.timeline.scrollLeft = left + speed;
      //     cancelAnimationFrame(timer);
      //     timer = requestAnimationFrame(aniFunc);
      //   } else {
      //     cancelAnimationFrame(timer);
      //     this.$refs.timeline.scrollLeft = target;
      //   }
      // };
      // cancelAnimationFrame(timer);
      // timer = requestAnimationFrame(aniFunc);
    },
    seeAllClick () {
      this.$router.push({path:'/system', query: {anchor: 'certificate'}} )
    }
  },
  components: {
    TimeLine,
    TimeLineItem,
    Tooltip,
  },
};
